export default __webpack_public_path__ + "static/media/mobile_12.5edb9693.png";